module.exports = __webpack_public_path__ + "static/media/icon-13.8ea4b8b3.png";